import axios from 'axios';

// Detecta automaticamente o ambiente
const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://growly-test-production-125d.up.railway.app'
    : 'http://localhost:5000');

// Logs para debug (apenas para confirmar no navegador)
console.log('🔍 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('🔍 NODE_ENV:', process.env.NODE_ENV);
console.log('🔍 API_BASE_URL FINAL:', API_BASE_URL);

// Criar instância do axios configurada
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para adicionar token automaticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('📤 Request:', config.method.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Interceptor para respostas
api.interceptors.response.use(
  (response) => {
    console.log('✅ Response:', response.status, response.config.url);
    return response;
  },
  async (error) => {
    console.error('❌ Response Error:', error.response?.status, error.config?.url);

    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');

        if (refreshToken) {
          const response = await axios.post(`${API_BASE_URL}/api/auth/refresh`, {
            refreshToken
          });

          const { accessToken, refreshToken: newRefreshToken } = response.data;

          localStorage.setItem('token', accessToken);
          localStorage.setItem('refreshToken', newRefreshToken);

          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error('❌ Erro ao renovar token:', refreshError);
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// Export dos endpoints
export const API_ENDPOINTS = {
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  REFRESH: '/auth/refresh',
  VERIFY: '/auth/verify',
  ME: '/auth/me',

  CAMPAIGNS: '/campaigns',
  CAMPAIGNS_ACTIVE: '/campaigns/active',
  CREATE_CAMPAIGN: '/campaigns/create',

  CREATIVES: '/creatives',
  UPLOAD_CREATIVE: '/creatives/upload',

  META_CAMPAIGN: '/meta/campaign',
  META_CAMPAIGNS: '/meta/campaigns',

  GOOGLE_ADS_AUTH: '/google-ads/authorize',
  GOOGLE_ADS_STATUS: '/google-ads/status',
  GOOGLE_ADS_CAMPAIGNS: '/google-ads/campaigns',

  TEST: '/test',
};

export { API_BASE_URL };
export default api;
